/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/10/2023
 */

import { Grid, Paper, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import styles from "./AvailabilityStep.module.css"
import { isMobile } from 'react-device-detect'
import { SET_DATE, SET_TIME } from '../../Pages/CheckoutPage'
import CheckoutContext from '../../Context/CheckoutContext'
import Summary from './Summary'
import ProfessionalSelect from './ProfessionalSelect'
import { useGetnextTenDaysQuery } from '../../Store/Services/DatesService'
import DateSelect from './DateSelect'
import TimeSelect from './TimeSelect'

const AvailabilityStep = ({ setIsDisabled, catId }) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);

    useEffect(() => {
        const UpdateDisabled = () => {
            if(checkoutData.dateId && checkoutData.timeSlotId) {
                setIsDisabled(false)
            } else {
                setIsDisabled(true)
            }
        }
        UpdateDisabled()
    }, [checkoutData])

    return (
        <div className={styles.container}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                    <Paper className={styles.paper} elevation={isMobile? 0: 3}>
                        <Typography className={styles.topic}>Date & Time</Typography>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>When would you like your service?</Typography>
                            <DateSelect setIsDisabled={setIsDisabled} />
                        </div>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>What time would you like to start?</Typography>
                            <TimeSelect setIsDisabled={setIsDisabled} />
                        </div>
                        <div className={styles.inputContainer}>
                            <Typography className={styles.subTitle}>Which professional do you prefer?</Typography>
                            <ProfessionalSelect catId={catId} />
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Summary />
                </Grid>
            </Grid>
        </div>
    )
}

export default AvailabilityStep